import React from 'react';
import { Table, Icon, Menu, Dropdown, Loader } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import Moment from 'moment';
import { withRouter } from 'react-router';

const SysadminClientListExportTable = (props) => {
    const paginationInfo = `${(props.perPage*props.currentPage)-props.perPage+1}-${(props.perPage*props.currentPage)>props.totalData ? props.totalData : (props.perPage*props.currentPage)} of ${props.totalData}`
    return (
        <Table celled selectable>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Policy No</Table.HeaderCell>
                    <Table.HeaderCell>Company Name</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            
            {props.clients.length == 0 &&
                <Table.Body>
                    <div style={{marginTop: "15px", marginBottom: "15px", marginLeft: "10px"}}>Result not found.</div>
                </Table.Body>
            }
            {props.clients.length > 0 && 
                <Table.Body>
                {
                    _.map(props.clients, (client) => {
                        const {
                            _id,
                            policyNo,
                            name,
                        } = client;
                        return (
                            <Table.Row key={_id}>
                                <Table.Cell>
                                        {policyNo}
                                </Table.Cell>
                                <Table.Cell>{name}</Table.Cell>
                            </Table.Row>
                        );
                    })
                }
                </Table.Body>
            }
            
            <Table.Footer>
                <Table.Row>
                    <Table.HeaderCell colSpan='8'>
                        <Menu floated='right' pagination>
                            <Menu.Item as='a' icon onClick={props.goToPreviousPage}
                                disabled={props.currentPage === 1}>
                                <Icon name='chevron left'/>
                            </Menu.Item>
                            <Menu.Item>{paginationInfo}</Menu.Item>
                            <Menu.Item as='a' icon onClick={props.goToNextPage}
                                disabled={!props.isShowNextButton}>
                                <Icon name='chevron right'/>
                            </Menu.Item>
                        </Menu>
                        <Menu floated='right' pagination>
                            <Menu.Item>Page</Menu.Item>
                            <Dropdown scrolling item text={props.currentPage.toString()} defaultValue={props.currentPage}>
                                <Dropdown.Menu>
                                    {[...Array(props.totalPage)].map((e, i) =>
                                        <Dropdown.Item key={i} onClick={() => props.setPage(i+1)}>{i+1}</Dropdown.Item>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Menu>
                        <Menu floated='right' pagination>
                            <Menu.Item>View</Menu.Item>
                            <Dropdown item text={props.perPage.toString()} defaultValue={props.perPage}>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => props.setPerPage(10)}>10</Dropdown.Item>
                                    <Dropdown.Item onClick={() => props.setPerPage(20)}>20</Dropdown.Item>
                                    <Dropdown.Item onClick={() => props.setPerPage(50)}>50</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Menu>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Footer>
        </Table>
    );
}

export default withRouter(SysadminClientListExportTable);